import { useEffect, useState } from "react";
import { getSettings } from "./adminApi";

let _cache = null; // in-session cache to avoid refetching across sections

export function useSettings() {
  const [s, setS] = useState(_cache);
  useEffect(() => {
    if (_cache) { setS(_cache); return; }
    let alive = true;
    getSettings()
      .then((d) => { if (d && d.hero) { _cache = d; if (alive) setS(d); } })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return s;
}
